
/// <reference path="../../../../typings/tsd.d.ts" />
module warsApp.controllers {
    export interface IProcessFormsConfigurationScope extends angular.IScope {
        model: models.ProcessFormsConfigurationModel
    }

    export class ProcessFormsConfigurationController implements IController {
        constructor(
            private scope: IProcessFormsConfigurationScope,
            processConfigurationService: services.ProcessConfigurationService,
            $routeParams: angular.route.IRouteParamsService,
            formService: services.FormService,
            locationService: angular.ILocationService,
            dataSourceService: services.DataSourceService,
            securityMatrixService: services.SecurityMatrixService,
            deleteService: services.DeleteService,
            modalService:any)
        {
            var processConfigId = $routeParams["id"];

            this.scope.model = new models.ProcessFormsConfigurationModel(
                processConfigId,
                processConfigurationService,
                formService,
                locationService,
                dataSourceService,
                securityMatrixService,
                deleteService,
                modalService);
        }
    }
}

warsApp.registerController('ProcessFormsConfigurationController',
    [ '$scope', 'processConfigurationService', '$routeParams', 'formService', '$location',
        'dataSourceService', 'securityMatrixService', 'deleteService', 'ModalService']);